"use client";

import { useNewsletter } from "./newsLetter.hook";

const NewsLetter = () => {
  const { formik, isLoading } = useNewsletter();

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="items-center">
          <input
            name="email"
            type="email"
            placeholder="Enter your email address"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            className="mt-10 mb-3 p-2 rounded-md border-2 border-gray-300"
          />
          <button
            type="submit"
            className={`typography-paragraph-small ${
              isLoading || formik.isSubmitting
                ? "cursor-not-allowed"
                : "cursor-pointer bg-primary-500 hover:bg-primary-600 text-white py-2 px-2 rounded-md text-sm ml-2"
            }`}
            disabled={isLoading || formik.isSubmitting}
          >
            {isLoading || formik.isSubmitting ? "Subscribing..." : "Subscribe"}
          </button>
        </div>

        {formik.touched.email && formik.errors.email && (
          <div className="mt-1 text-sm text-red-400">{formik.errors.email}</div>
        )}
      </form>
    </div>
  );
};

export default NewsLetter;
